/**
 * @author: liaojianming
 * @date 2019-02-21
 * @description: 系统管理-组织架构模块
*/

import request from '@/plugin/axios';

const apiUrl = process.env.VUE_APP_API;

// 查询部门树形结构
export function QueryDepartmentTreeNode(data) {
    return request({
        url: apiUrl + 'system_dept/tree_dept',
        method: 'POST',
        data
    });
}

// 新增部门节点
export function AddDepartmentTreeNode(data) {
    return request({
        url: apiUrl + 'system_dept/add_dept_node',
        method: 'POST',
        data
    });
}

// 查询部门节点详情
export function QueryDepartmentTreeNodeInfo(data) {
    return request({
        url: apiUrl + 'system_dept/detail_by_id',
        method: 'POST',
        data
    });
}

// 更新部门节点
export function UpdateDepartmentTreeNode(data) {
    return request({
        url: apiUrl + 'system_dept/update_for_ordinary',
        method: 'POST',
        data
    });
}

// 删除部门节点
export function DeleteDepartmentTreeNode(data) {
    return request({
        url: apiUrl + 'system_dept/delete_dept_node',
        method: 'POST',
        data
    });
}

// 根据部门id获取该部门下所有用户列表
export function QueryUserByDepartmentId(data) {
    return request({
        url: apiUrl + 'system_dept/list_all_users_by_dept_id',
        method: 'POST',
        data
    });
}